<div *ngIf="_cs.isBrowser" class="imageCropper-overlay">
  <div
    class="imageCropper-container banner-cropper"
    [ngClass]="getContainerClass()"
    [ngStyle]="getContainerStyle()"
  >
    <div class="imageCropper-box new-box">
      <div class="adjust-image-size">{{ NEW_POST_CONSTANTS.ADJUST_YOUR_IMAGE }}</div>
      <div class="cropper-wrapper">
        <image-cropper
          [imageChangedEvent]="imageChangeEvent"
          [maintainAspectRatio]="cropperOptions.maintainAspectRatio ?? true"
          [aspectRatio]="cropperOptions.aspectRatio"
          [cropperMinWidth]="cropperOptions.cropperMinWidth"
          [cropperMinHeight]="cropperOptions.cropperMinHeight"
          [cropperStaticWidth]="cropperOptions.cropperStaticWidth || null"
          [cropperStaticHeight]="cropperOptions.cropperStaticHeight || null"
          [cropperMaxWidth]="cropperOptions.cropperMaxWidth || null"
          [cropperMaxHeight]="cropperOptions.cropperMaxHeight || null"
          [resizeToWidth]="0"
          [onlyScaleDown]="true"
          format=".png"
          class="imageCropper imageCropperprofile"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          [roundCropper]="roundCropper"
        ></image-cropper>
      </div>
      <div class="recommended-size" *ngIf="cropperOptions.recommendedText || (cropperOptions.cropperMinWidth && cropperOptions.cropperMinHeight)">
        {{ cropperOptions.recommendedText || (NEW_POST_CONSTANTS.RECOMMENDED_SIZE + (cropperOptions.recommendedWidth ?? cropperOptions.cropperMaxWidth ?? cropperOptions.cropperMinWidth) + 'px Wide x ' + (cropperOptions.recommendedHeight ?? cropperOptions.cropperMaxHeight ?? cropperOptions.cropperMinHeight) + 'px Tall') }}
      </div>
    </div>
    <div class="imageCropper-footer">
      <button class="btn btn-default" (click)="cancelCrop(false)">
        Cancel
      </button>
      <button class="btn btn-primary" (click)="pickProfile()">
        <span class="loading-spinner" *ngIf="spinner"></span>
        Upload
      </button>
    </div>
  </div>
</div>